import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./global-styles/theme";
// import './index.css';
import Cuvo from "./components/app";
import { createRoot } from "react-dom/client";
import UserProvider from "./context/userContext";

// import WithRoot from "./withRoot";
// import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

// const rootEl = document.getElementById("root");
// ReactDOM.render(<WithRoot />, rootEl);
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript

  root.render(
    <React.StrictMode>
      <UserProvider>
        <ThemeProvider theme={theme}>
          <Cuvo />
        </ThemeProvider>
      </UserProvider>
    </React.StrictMode>
  );
}

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <ThemeProvider theme={theme}>
//       <Cuvo />
//     </ThemeProvider>
//   </React.StrictMode>
// );

// comment in for PWA with service worker in production mode
// registerServiceWorker();

// unregisterServiceWorker();
